import api from 'data/api';

export const loadChannels = api('GET /api/mobile/lookups/channels');
